import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../../app.service';

@Component({
  selector: 'si-dashboard-refresh-timer',
  templateUrl: './dashboard-refresh-timer.component.html',
  styleUrls: ['./dashboard-refresh-timer.component.scss']
})
export class DashboardRefreshTimerComponent implements OnInit {

  @Input() title: string;

  timerInterval: any;
  dt: any;
  preObj: any;
  localTime: any;
  display: any;
  diffMilSec: any;
  timeOut: any;
  isRefreshTime: boolean = true;
  refreshDate: any;
  dateFrom: any;
  dateTo: any;
  isAutoRefreshDisabled: any;
  constructor(private appService: AppService) { }

  ngOnInit() {
  }

  /**
     * Showing Timer
     * @param last refresh date and time
     */
  startTimer(res) {
    this.timerInterval = setInterval(() => {
      this.dt = new Date(res.replace(/-/g, '/') + ' UTC');
      this.localTime = new Date();
      const distance: any = 1200000 - (this.localTime - this.dt);
      let minutes: any = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds: any = Math.floor((distance % (1000 * 60)) / 1000);
      minutes = (minutes === -1) ? 0 : minutes;
      seconds = (seconds === -1) ? 0 : seconds;
      minutes = (minutes < 10) ? '0' + minutes : minutes;
      seconds = (seconds < 10) ? '0' + seconds : seconds;
      this.display = minutes + ':' + seconds + ' Min ';
      if (distance < 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

   /**
   * Determines last page refresh information
   * @param updated timezone & abbreviation
   */
    setLastDataRefresh(res, m) {
       try {
         clearTimeout(this.timerInterval);

         // Validate input
         if (!res) {
           console.warn('No update_time provided to setLastDataRefresh');
           this.refreshDate = this.getLocalTimeWithTimezone(new Date());
           return;
         }

         // Parse UTC timestamp and convert to local timezone
         this.dt = new Date(res.replace(/-/g, '/') + ' UTC');
         this.localTime = new Date();
         const diffMilSec = 1200000 - (this.localTime - this.dt);
         const diffMins = diffMilSec / 60000;

         // Ensure m is properly initialized
         if (!m) {
           m = {
             updatedTimeZone: null,
             abbr: null,
             auto_refresh: false
           };
         }

         // Get timezone abbreviation from browser's local timezone
         const tzAbbr = this.getTimezoneAbbreviation();

         // Display time in user's local timezone (browser default)
         this.refreshDate = this.dt.toLocaleString('en-US') + ' ' + tzAbbr;

         console.log('Last page refresh set to:', this.refreshDate);

         this.isRefreshTime = false;
         this.startTimer(res);
         if (m.auto_refresh) {
           this.timeOut = setTimeout(() => {
             this.onRefresh();
           }, diffMilSec);
         } else {
           clearTimeout(this.timerInterval);
           this.display = '';
         }
       } catch (error) {
         console.error('Error in setLastDataRefresh:', error);
         this.refreshDate = this.getLocalTimeWithTimezone(new Date());
       }
    }

   /**
    * Get timezone abbreviation from browser's local timezone
    */
   private getTimezoneAbbreviation(): string {
     try {
       // Get the timezone name using Intl API
       const formatter = new Intl.DateTimeFormat('en-US', {
         timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
         timeZoneName: 'short'
       });
       const parts = formatter.formatToParts(new Date());
       const tzPart = parts.find(part => part.type === 'timeZoneName');
       if (tzPart && tzPart.value) {
         return tzPart.value;
       }

       // Fallback: extract from toLocaleString
       const timeString = new Date().toLocaleString('en-US', { timeZoneName: 'short' });
       const matches = timeString.match(/\b([A-Z]{2,4})\b/);
       return matches ? matches[1] : 'UTC';
     } catch (error) {
       console.warn('Error getting timezone abbreviation:', error);
       return 'UTC';
     }
   }

   /**
    * Format date with local timezone abbreviation
    */
   private getLocalTimeWithTimezone(date: Date): string {
     try {
       const tzAbbr = this.getTimezoneAbbreviation();
       return date.toLocaleString('en-US') + ' ' + tzAbbr;
     } catch (error) {
       return date.toLocaleString('en-US');
     }
   }

  /**
     * refresh data
     * @param event
     */
  onRefresh() {
    this.isRefreshTime = true;
    // this.onFilterSelection(this.cloneDataParam);
  }

  /**
     * Determines what to do on filter selection, sets fetched dates. changes loader status
     * @param combinedData
     */
  /* onFilterSelection(combinedData) {
    this.cloneDataParam = combinedData;
    this.isRefreshTime = true;
    this.isChartPlotted['key'] = false;
    if (combinedData.selectedDate) {
      this.selectedApi = combinedData.selectedApi;
      this.selectedServiceType = combinedData.selectedServiceType;
      this.selectedRegion = combinedData.selectedRegion;
      this.dateFrom = this.formateDate(combinedData.selectedDate.date[0]);
      if (combinedData.selectedDate.date[1] != null) {
        this.dateTo = this.formateDate(combinedData.selectedDate.date[1]);
      } else {
        this.dateTo = this.formateDate(combinedData.selectedDate.date[0]);
      }

      this.getStatusDetails(combinedData);
    } else {
      this.changeLoaderStatus(false);
      this.apiList = [];
      this.responseBackupData = [];
      this.sipUpdatedData = [];
      this.attestationUpdatedData = [];
    }
    this.dataService.getDateList().subscribe(
      (response) => {
        const res = response[0]['update_time'];
        this.rawRefreshTimeResponse = response[0]['update_time'];
        this.setLastDataRefresh(res, this.preObj);
      }, (error) => {
      });
  } */

}
